import React from 'react'
import { Form } from 'react-bootstrap'
import DOMpurify from 'dompurify'

const ControlInput = ({ input, meta, type, placeholder, min, max }) => {
    const escapedValue = DOMpurify.sanitize(input.value)
  // TODO NTH handle the warning case if needed (not handled in bootstrap ?)
  return (
    <div>
      <Form.Control as="input"
        {...input}
        type="password"
        placeholder={placeholder}
        min={min}
        max={max}
        value={escapedValue}
        isInvalid={
          (meta.touched && (meta.error || meta.warn))
          || (meta.submitError && !meta.dirtySinceLastSubmit)
        }
      />

      {meta.touched &&
        ((meta.error && <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>) ||
         (meta.warning && <Form.Control.Feedback type="invalid">{meta.warning}</Form.Control.Feedback>))}

      {meta.submitError && !meta.dirtySinceLastSubmit ? <Form.Control.Feedback type="invalid">{meta.submitError}</Form.Control.Feedback> : null}

    </div>
  )
}

export default ControlInput
